import { render, staticRenderFns } from "./highPro.vue?vue&type=template&id=5a4fab61&scoped=true&"
import script from "./highPro.vue?vue&type=script&lang=js&"
export * from "./highPro.vue?vue&type=script&lang=js&"
import style0 from "./highPro.vue?vue&type=style&index=0&id=5a4fab61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4fab61",
  null
  
)

export default component.exports